import { IMG_HISTORY_TITLE } from "../const";
import style from "./history.css";

const kzs = window.kzs;
const $ = kzs.$;

interface HistoryData {
  name?: string;
  path?: string;
  updatedAt: string;
}

class History {
  setHistory(history: Array<HistoryData>) {
    kzs(
      "setUserData",
      {
        kzCarModelViewHistory: JSON.stringify(history),
        __kzCarModelViewHistory: {
          mode: "prepend", // 最後に追加した情報が先頭に来る (or "append")
          limit: 4, // 履歴の最大保持数 (=最新 10 件だけ保持。指定なしの default は 100)
          unique: true, // 履歴に同じデータがあった際に追加させないモード (default は false)
        },
      },
      () => {
        //
        kzs.console.log(`userData - kzCarModelViewHistory is set.`);
      }
    );
  }

  getHistory(): Array<HistoryData> {
    if (!kzs.current.userData.kzCarModelViewHistory?.length) return [];

    let histories = JSON.parse(kzs.current.userData.kzCarModelViewHistory) || [];

    // 閲覧後7日以内のデータに絞る
    const today = new Date();
    const week = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    histories = histories.filter((x: HistoryData) => new Date(x.updatedAt) > week);
    this.setHistory(histories);

    return histories;
  }

  clearHistory(): void {
    kzs(
      "setUserData",
      {
        kzCarModelViewHistory: [],
      },
      () => {
        //
        kzs.console.log(`userData - kzCarModelViewHistory is clear.`);
      }
    );
  }
}

export default new History();

export const updateHistory = (history: History): void => {
  let histories = history.getHistory();

  histories = histories.filter((x) => x.path != location.pathname);
  histories.push({ path: location.pathname, updatedAt: new Date().toLocaleString() });
  kzs.console.log("histories ::: ", histories);
  history.setHistory(histories);
};

export const showHistory = (history: History): void => {
  style.use();

  const histories = history.getHistory();
  console.log(histories);

  if (histories.length > 0) {
    $(".l-lineup").before(
      $(`
        <section class="kz-history">
          <div class="l-section">
            <h2 class="head--lv1">
              <img src="${IMG_HISTORY_TITLE}"
                class="tien"
                data-original="${IMG_HISTORY_TITLE}"
                alt="過去に閲覧した車種">
            </h2>
          </div>
          <div class="kz-lineup-model-wrap">
            <div class="kz-lineup-model-inner">
              <div class="kz-lineup-model"></div>
            </div>
          </div>
        </section>
      `)
    );

    $.each(histories.reverse(), (_i, d) => {
      kzs.console.log("history :::", _i, d.path, d.updatedAt);
      if (_i > 3 || !d.path) return;

      const $item = $(".l-lineup .lineup-model, .l-lineup .lineup-body")
        .find(`a.item[href*="${d.path}"]`)
        .eq(0)
        .clone()
        .removeClass("mt0");
      if ($item) $(".kz-history .kz-lineup-model").append($item);
    });
  }
};
